<template>
  <div class="new-product body">
    <el-container>
      <!-- <ProductsAside /> -->

      <el-main>
        <el-card>
          <template slot="header"> اضافة منتج جديد </template>
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            label-width="130px"
            class="demo-ruleForm"
          >
            <div>
              <el-row :gutter="10">
                <el-col :xl="6" :lg="6" :md="12" :sm="12">
                  <el-form-item
                    label="  حدد التصنيف"
                    prop="product_category_id"
                  >
                    <el-select
                      style="width: 100%"
                      v-model="form.product_category_id"
                      placeholder=" حدد التصنيف"
                      @focus="index = 1"
                      id="input1"
                      @change="focusNext()"
                      class="mt-2 input1"
                      :filterable="true"
                      clearable
                    >
                      <el-option
                        v-for="item in productCategories"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xl="10" :lg="10" :md="24" :sm="24">
                  <el-form-item label="اسم المنتج" prop="name">
                    <el-input
                      class="mt-2 input2"
                      @focus="$event.target.select(), (index = 2)"
                      v-model="form.name"
                      @keyup.enter.native="focusNext"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12">
                  <el-form-item label="عدد الوحدات" prop="units_per_package">
                    <el-input
                      class="mt-2 input3"
                      id="units_per_package"
                      type="number"
                      @focus="$event.target.select(), (index = 3)"
                      v-model="form.units_per_package"
                      controls-position="right"
                      @keyup.enter.native="focusNext"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12">
                  <div class="searchForm">
                    <el-form-item label="الوحدة " prop="priceListUnit">
                      <el-input
                        class="mt-2 input4"
                        id="unit"
                        @focus="$event.target.select(), (index = 4)"
                        v-model="form.priceListUnit"
                        @keyup.enter.native="focusNext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="10">
                <el-col :xl="4" :lg="4" :md="12" :sm="12">
                  <div class="searchForm">
                    <el-form-item label=" سعر الجملة" prop="sale_price">
                      <el-input
                        class="mt-2 input5"
                        type="number"
                        id="sale_price"
                        @focus="$event.target.select(), (index = 5)"
                        v-model="form.sale_price"
                        @keyup.enter.native="focusNext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12">
                  <div class="searchForm">
                    <el-form-item
                      label=" سعر جملة الجملة "
                      prop="wholesale_price"
                    >
                      <el-input
                        class="mt-2 input6"
                        type="number"
                        id="wholesale_price"
                        @focus="$event.target.select(), (index = 6)"
                        v-model="form.wholesale_price"
                        @keyup.enter.native="focusNext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <!-- <el-col :xl="4" :lg="4" :md="12" :sm="12">
                  <el-form-item label=" سعر فاتورة" prop="fatura_price">
                    <el-input
                      class="mt-2 input7"
                      type="number"
                      id="sale_price"
                      @focus="$event.target.select(), (index = 6)"
                      v-model="form.fatura_price"
                      @keyup.enter.native="focusNext"
                    ></el-input>
                  </el-form-item>
                </el-col> -->
                <el-col :xl="4" :lg="4" :md="12" :sm="12">
                  <div class="searchForm">
                    <el-form-item label="  اقل سعر">
                      <el-input
                        class="mt-2 input8"
                        id="min_price"
                        type="number"
                        @focus="$event.target.select(), (index = 7)"
                        v-model="form.priceList[0].min_price"
                        controls-position="right"
                        @keyup.enter.native="focusNext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12">
                  <div class="searchForm">
                    <el-form-item label=" كود المنتج    ">
                      <el-input
                        class="mt-2 input9"
                        type="number"
                        id="code"
                        @focus="$event.target.select(), (index = 4)"
                        v-model="form.priceList[0].code"
                        @keyup.enter.native="focusNext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="12" :sm="12">
                  <div class="searchForm">
                    <el-form-item label="  حد الطلب " prop="min_threshold">
                      <el-input
                        class="mt-2 input10"
                        id="min_threshold"
                        type="number"
                        :min="10"
                        @focus="$event.target.select(), (index = 8)"
                        v-model="form.min_threshold"
                        controls-position="right"
                        @keyup.enter.native="focusNext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col
                  :xl="4"
                  :lg="4"
                  :md="12"
                  :sm="12"
                  v-if="form.priceList.length == 1"
                >
                  <br />
                  <el-button class="mt-2" type="warning" @click="addNewUnit">
                    اضافة وحدة فرعية</el-button
                  >
                </el-col>
                <template v-if="form.priceList.length == 2">
                  <el-col :span="24">
                    <el-card shadow="never">
                      <div slot="header" class="clearfix">
                        <span>الوحدة الفرعية</span>
                      </div>
                      <div class="text item">
                        <el-col :xl="4" :lg="4" :md="12" :sm="12">
                          <div class="searchForm">
                            <el-form-item label="الوحدة ">
                              <el-input
                                class="mt-2 input4"
                                id="unit"
                                v-model="form.priceList[1].unit"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="12" :sm="12">
                          <div class="searchForm">
                            <el-form-item label=" سعر الجملة">
                              <el-input
                                class="mt-2 input6"
                                type="number"
                                id="sale_price"
                                v-model="form.priceList[1].sale_price"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="12" :sm="12">
                          <div class="searchForm">
                            <el-form-item label=" سعر جملة الجملة">
                              <el-input
                                class="mt-2 input6"
                                type="number"
                                id="wholesale_price"
                                v-model="form.priceList[1].wholesale_price"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <!-- <el-col :xl="4" :lg="4" :md="12" :sm="12">
                          <div class="searchForm">
                            <el-form-item label=" سعر فاتوره ">
                              <el-input
                                class="mt-2 input6"
                                type="number"
                                id="fatura_price"
                                v-model="form.priceList[1].fatura_price"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col> -->

                        <el-col :xl="4" :lg="4" :md="12" :sm="12">
                          <div class="searchForm">
                            <el-form-item label=" كود المنتج  ">
                              <el-input
                                class="mt-2 input5"
                                type="number"
                                id="code"
                                @focus="$event.target.select(), (index = 4)"
                                v-model="form.priceList[1].code"
                                @keyup.enter.native="focusNext"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>

                        <el-col :xl="4" :lg="4" :md="12" :sm="12">
                          <br />
                          <el-button
                            class="mt-2"
                            type="danger"
                            @click="removeUnit"
                          >
                            <i class="fas fa-trash-alt"></i
                          ></el-button>
                        </el-col>
                      </div>
                    </el-card>
                  </el-col>
                </template>
              </el-row>
              <el-col :xl="4" :lg="4" :md="12" :sm="12">
                <br />
                <el-button
                  class="mt-2"
                  type="warning"
                  @click="submitForm('form')"
                >
                  تسجيل</el-button
                >
              </el-col>
              <div class="clearfix"></div>
            </div>
          </el-form>
        </el-card>

        <el-card>
          <template slot="header"> إضافة المنتجات عن طريق ملف </template>
          <!-- Upload using excell sheet -->
          <!-- class="avatar-uploader mx-auto" -->

          <el-col :xl="6" :lg="6" :md="12" :sm="12">
            <el-select
              style="width: 100%"
              v-model="category_id"
              placeholder=" حدد التصنيف"
              @focus="index = 1"
              class="mt-2 mb-5"
              :filterable="true"
              clearable
            >
              <el-option
                v-for="item in productCategories"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :xl="6" :lg="6" :md="12" :sm="12">
            <el-upload
              class="mt-2 mr-2"
              :auto-upload="false"
              :file-list="fileList"
              action="#"
              ref="productsFile"
              :on-change="handleUpload"
            >
              <!-- list-type="picture-card" -->
              <!-- :on-remove="handleUpload" -->
              <template slot="trigger">
                <el-button class="btn btn-blue" type="primary">
                  حدد ملف المنتجات
                </el-button>
              </template>
            </el-upload>
          </el-col>

          <el-col :xl="4" :lg="4" :md="12" :sm="12">
            <el-button class="mt-2" type="warning" @click="uploadFile">
              رفع المنتجات</el-button
            >
          </el-col>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import ProductsAside from "@/components/ProductsAside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "NewProduct",
  // components: { ProductsAside },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "مطلوب",
            trigger: "blur",
          },
        ],
        min_threshold: [
          {
            required: true,
            message: "مطلوب",
            trigger: "blur",
          },
        ],
        product_category_id: [
          {
            required: true,
            message: "مطلوب",
            trigger: "change",
          },
        ],
        units_per_package: [
          {
            required: true,
            message: "مطلوب",
            trigger: "blur",
          },
        ],
        priceListUnit: [
          {
            required: true,
            message: "مطلوب",
            trigger: "blur",
          },
        ],
        wholesale_price: [
          {
            required: true,
            message: "مطلوب",
            trigger: "blur",
          },
        ],
        sale_price: [
          {
            required: true,
            message: "مطلوب",
            trigger: "blur",
          },
        ],
        // fatura_price: [
        //   {
        //     required: true,
        //     message: "مطلوب",
        //     trigger: "blur",
        //   },
        // ],
      },
      fileList: [],
      category_id: null,
      index: 2,
      false: false,
      productCategories: [],
      form: {
        name: "",
        product_category_id: null,
        inventory_id: 1,
        units_per_package: "",
        min_threshold: 10,
        priceList: [
          {
            code: null,
            barcode: null,
            wholesale_price: "",
            sale_price: 0,
            fatura_price: 0,
            unit: "",
            min_price: "",
            type: 1,
          },
        ],
        priceListUnit: "",
        wholesale_price: "",
        sale_price: "",
        fatura_price: "",
      },
    };
  },
  created() {
    this.getCategories();
  },
  mounted() {
    //  document.getElementById('input1').focus();
  },

  methods: {
    handleUpload() {
      this.fileList = this.$refs.productsFile.uploadFiles;
      console.log(this.fileList);
    },
    uploadFile() {
      if (
        this.fileList &&
        this.fileList.length > 0 &&
        this.category_id != null
      ) {
        const loading = this.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
      });

        let formData = new FormData();
        formData.append("category_id", this.category_id);
        formData.append("inventory_id", 1);
        this.fileList.map((file) => {
          if (file.status == "ready") {
            formData.append("file", file.raw);
          }
        });

        axiosApi
          .post("/products/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            this.$notify({
              title: "تمت العملية بنجاح",
              message: "تم تحميل المنتجات بجاح",
              type: "success",
              duration: 1500,
            });
            this.fileList = [];
          })
          .catch(() => {})
          .finally(() => loading.close());
      } else {
        this.$notify({
          title: "تمت العملية بنجاح",
          message: "من فضلك حدد الملف والتصنيف أولا",
          type: "error",
          duration: 1500,
        });
      }
    },
    removeUnit() {
      this.form.priceList.splice(1, 1);
    },
    addNewUnit() {
      this.form.priceList.push({
        code: null,
        barcode: null,
        wholesale_price: "",
        sale_price: 0,
        fatura_price: 0,
        unit: "",
        min_price: "",
        type: 2,
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.priceList[0].unit = this.form.priceListUnit;
          this.form.priceList[0].wholesale_price = this.form.wholesale_price;
          this.form.priceList[0].sale_price = this.form.sale_price;
          this.form.priceList[0].fatura_price = this.form.wholesale_price;
          axiosApi
            .post("products", this.form)
            .then(() => {
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات العميل بنجاح",
                type: "success",
                duration: 1500,
              });
              this.$refs[formName].resetFields();
              this.form = {
                name: "",
                product_category_id: null,
                inventory_id: 1,
                units_per_package: "",
                min_threshold: 10,
                priceList: [
                  {
                    code: null,
                    barcode: null,
                    wholesale_price: "",
                    sale_price: 0,
                    fatura_price: 0,
                    unit: "",
                    min_price: "",
                    type: 1,
                  },
                ],
                priceListUnit: "",
                wholesale_price: "",
                sale_price: "",
                fatura_price: "",
              };
              // setTimeout(() => {
              //   location.reload();
              // }, 1000);
            })
            .catch(() => {
              this.$notify({
                title: "حدث خطأ",
                message: "عفوا لم تتم العملية ",
                type: "error",
                duration: 1500,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    focusNext() {
      if (this.index < 8) {
        this.index += 1;
        let input = ".input" + this.index + " input";
        console.log(input);
        setTimeout(() => {
          document.querySelector(input).focus();
        }, 100);
      } else {
        this.index = 1;
        //   document.querySelector('.input1 select').focus();
      }
    },
    getCategories() {
      axiosApi
        .get("product-categories")
        .then((res) => {
          this.productCategories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    addNewProduct() {
      axiosApi
        .post("products", this.form)
        .then(() => {
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات العميل بنجاح",
            type: "success",
            duration: 1500,
          });
          setTimeout(() => {
            location.reload();
          }, 1000);
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
  },
};
</script>
